import { useEffect, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Message from "@/components/Message/index";
import SvgsCommons from "@/components/svgs/commons";
import { newPath, EmailHost, EmailLink, NFTsLink, SubhubHost, DmailDocs, GitBookLink, SubHubLink, BlogLink, ContactLink, RoadMapLink, TermsServiceLink, PrivacyPolicyLink } from '@/utils/index'
import Fly from '@/static/images/fly.png'
import { Contact } from './css'

const Chunk = ({ store, location: { pathname } }) => {
  const { isMobile, windowSize } = store.common;
  const history = useHistory();

  const comming = () => Message({
    type: '',
    msg: <span className="fly"><img src={Fly} width={30} className='fly' /><strong>Coming soon!</strong></span>
  })

  const domLogo = <a href="/"><SvgsCommons type="logo" width={155} height={42} /></a>
  const domDmail = <p>contact@mail.dmail.ai</p>

  const scrollToMsgProtocol = () => {
    const target = document.querySelector(`#_msgProtocol`)
    target && target.scrollIntoView && target.scrollIntoView({ behavior: "smooth", block: 'start' })
  }
  const viewMsgProtocol = () => {
    if (pathname === `${newPath}/`) {
      scrollToMsgProtocol()
      setTimeout(() => {
        const header = document.querySelector('header.top10')
        header && header.classList.remove('top10')
        header && header.classList.add('hideTop')
      }, 800);
    } else {
      history.push(`${newPath}/#dmp`)
    }
  }
  useEffect(() => {
    if (pathname === `${newPath}/` && location.hash === '#dmp') {
      scrollToMsgProtocol()
    }
  }, [pathname])

  return (
    <Contact className={isMobile ? 'sub-mobile center' : 'center'}>
      <div className="left">
        {domLogo}
        <p>Dmail Network is an AI-powered decentralized communication infrastructure built to provide encrypted emails, unified notifications, and targeted marketing across multiple chains and dApps for users, developers, and marketers.</p>
        {domDmail}
      </div>
      <div className="right">
        <dl>
          <dt>Products</dt>
          <dd><a href={EmailLink} target="_blank">Dmail DApp</a></dd>
          <dd><a href={SubhubHost} target="_blank">Subscription & Notification</a></dd>
          <dd><a href={SubHubLink} target="_blank">Marketing Hub</a></dd>
          {/* <dd><a onClick={comming}>Marketing Hub</a></dd> */}
          <dd><a href={`${EmailHost}/domain`} target="_blank">Domain</a></dd>
          <dd><a href={NFTsLink} target="_blank">3D Crystals</a></dd>
        </dl>
        <dl>
          <dt>Resources</dt>
          <dd><a href={GitBookLink} target="_blank">Docs</a></dd>
          <dd><a href={BlogLink} target="_blank">Blog</a></dd>
          {/* <dd><a href={DmailDocs} target="_blank">$DMAIL</a></dd> */}
          <dd><a onClick={() => history.push(`${newPath}/ambassador`)}>Ambassador</a></dd>
        </dl>
        <dl>
          <dt>Developers</dt>
          {/* <dd><a onClick={viewMsgProtocol}>Msg Protocol</a></dd> */}
          <dd><a href="https://forms.gle/Z6pb3QSi8pwhAbZw6" target="_blank">Bug Bounty</a></dd>
          <dd><a href="https://mail.dmail.ai/hubs/subcenter" target="_blank">Ecosystem</a></dd>
        </dl>
        <dl>
          <dt>About Us</dt>
          <dd><a href={ContactLink} target="_blank">Contact</a></dd>
          <dd><a href={RoadMapLink} target="_blank">Roadmap</a></dd>
          <dd><a href={TermsServiceLink} target="_blank">Terms of Service</a></dd>
          <dd><a href={PrivacyPolicyLink} target="_blank">Privacy Policy</a></dd>
        </dl>
      </div>   
    </Contact>
  )
}

export default withRouter(inject("store")(observer(Chunk)))